import React, { useState, useEffect } from "react";
import StyledDrawer from "../StyledDrawer";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  makeStyles,
  Divider,
  IconButton
} from "@material-ui/core";
import { connect } from "react-redux";
import BillingOverview from "./BillingOverview";
import InvoicesTab from "./InvoicesTab";
import {
  Link as RouterLink,
  Route,
  Redirect,
  Switch,
  useLocation
} from "react-router-dom";
import { setActiveDialog, setInvoices } from "../../../store/actions/account";
import API from "../../../utils/axios";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(theme => ({
  accountHeader: {
    boxSizing: "border-box"
  },
  tabsWrapper: {
    padding: theme.spacing(0, 1),
    marginBottom: -1,
    marginTop: theme.spacing(3),
    minHeight: theme.spacing(5)
  },
  tabItem: {
    minWidth: "0",
    textTransform: "none",
    fontSize: "0.875rem",
    padding: theme.spacing(1, 0, 1.75),
    margin: theme.spacing(0, 2),
    lineHeight: "1rem",
    minHeight: theme.spacing(5),
    color: theme.palette.secondary.main
  },
  primary: {
    color: theme.palette.text.primary + "!important"
  },
  title: {
    fontSize: "1.25rem",
    lineHeight: "1.4375rem",
    fontWeight: 500
  },
  iconButton: {
    marginLeft: "-0.5rem",
    marginRight: theme.spacing(2),
    "& svg": {
      width: theme.spacing(3),
      height: theme.spacing(3)
    }
  },
  divider: {
    backgroundColor: "#DDD"
  }
}));

function BillingDialog({
  open,
  handleClose,
  saveDisabled,
  drawerExpanded,
  setActiveDialog,
  invoices,
  setInvoices
}) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    if (newValue !== value) {
      if (saveDisabled) {
        setValue(newValue);
      }
    }
  };

  const [billEstimate, setBillEstimate] = useState(null);
  const [billEstimateLoaded, setBillEstimateLoaded] = useState(null);

  useEffect(() => {
    if (open) {
      setBillEstimateLoaded(false);
      API.get("v1/stripe/invoices/upcoming")
        .then(res => {
          setBillEstimate(res.data);
          setBillEstimateLoaded(true);
        })
        .catch(err => {
          setBillEstimateLoaded(true);
        });
    }
  }, [open]);

  const [invoicesLoaded, setInvoicesLoaded] = useState(false);

  useEffect(() => {
    API.get("v1/stripe/invoices")
      .then(res => {
        setInvoicesLoaded(true);
        setInvoices(
          res.data.map(invoice => {
            const {
              id,
              invoicePdf,
              status,
              amountPaid,
              created,
              number,
              currency,
              hostedInvoiceUrl
            } = invoice;
            return {
              id,
              invoicePdf,
              status,
              amountPaid,
              created,
              number,
              currency,
              hostedInvoiceUrl
            };
          })
        );
      })
      .catch(err => {});

    return setValue(0);
  }, [setInvoices]);

  const location = useLocation();

  const [loading, setLoading] = useState(false);

  return (
    <StyledDrawer open={open} handleClose={handleClose} loading={loading}>
      <Box
        className={classes.accountHeader}
        display="flex"
        justifyContent="space-between"
        px={3}
        py={2.5}
      >
        <Box alignSelf="center" alignItems="center" display="flex" pr={2}>
          <IconButton
            onClick={() => handleClose()}
            className={classes.iconButton}
          >
            <CloseIcon />
          </IconButton>
          <Typography className={classes.title} variant="h5">
            Billing
          </Typography>
        </Box>
      </Box>

      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        className={classes.tabsWrapper}
      >
        <Tab
          label="Overview"
          component={RouterLink}
          value="/billing/overview"
          to="/billing/overview"
          classes={{ root: classes.tabItem, selected: classes.primary }}
        />
        <Tab
          label="Invoices"
          component={RouterLink}
          data-cy="invoicesLink"
          value="/billing/invoices"
          to="/billing/invoices"
          classes={{ root: classes.tabItem, selected: classes.primary }}
        />
      </Tabs>
      <Divider className={classes.divider} />
      <Box pl={3} pr={5} flexGrow="1" flexShrink="1" overflow="auto">
        <Switch>
          <Route path="/billing/(overview|edit-billing-details)">
            <BillingOverview
              value={value}
              index={0}
              drawerExpanded={drawerExpanded}
              setActiveDialog={setActiveDialog}
              billEstimate={billEstimate}
              billEstimateLoaded={billEstimateLoaded}
              setLoading={setLoading}
            />
          </Route>
          <Route path="/billing/invoices">
            <InvoicesTab
              value={value}
              index={1}
              invoicesLoaded={invoicesLoaded}
              drawerExpanded={drawerExpanded}
              setLoading={setLoading}
              invoices={invoices}
            />
          </Route>
          <Redirect to="/billing/overview" />
        </Switch>
      </Box>
    </StyledDrawer>
  );
}

const mapStateToProps = state => ({
  invoices: state.account.invoices
});

export default connect(mapStateToProps, { setActiveDialog, setInvoices })(
  BillingDialog
);
